var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog"},[_c('h3',{staticClass:"dialog__title text-center"},[_vm._v(_vm._s(_vm.$t('Confirm action')))]),_c('m-form-block',{attrs:{"onSubmit":_vm.submit,"fields":_vm.fields,"button-text":"Confirm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }